import {
  SET_APP_INFO,
} from '../types';

const defaultState = {
  app: {
    type: null,
  },
};

const app = (state = defaultState.app, action) => {
  switch (action.type) {
    case SET_APP_INFO:
      return Object.assign({}, defaultState.app, {
        type: action.payload.type,
      });

    default:
      return state;
  }
};

export default app;



// WEBPACK FOOTER //
// ./src/state/reducers/app.js